define('glu/grid/state/stateModel',['require','../../model','../../appBus','../../util'],function(require) {
    'use strict';

    var Model = require('../../model'),
        appBus = require('../../appBus'),
        util = require('../../util');

    return Model.extend({
        defaults: {
            'sort': {},
            'multiColumnSort': {},
            'hiddenColumns': [],
            'columnsWidth': {},
            'columnOrder': [],
            'filters': {}
        },
        initialize: function(attributes, options) {
            this.grid = options.grid;
            this.sendArray = options.array;
            this.savedJSON = this.toJSON();
            this.listenTo(this, 'change', this.update);
        },

        convertToArray: function(json) {
            return [json.pageSize, json.currentPage, json.sort, json.columnOrder, json.hiddenColumns, json.filters, json.multiColumnSort, json.columnsWidth];
        },
        convertState: function(json) {
            return this.sendArray ? this.convertToArray(json) : json;
        },
        update: function() {
            var currentJSON = this.toJSON();

            if (!util.isEqual(currentJSON, this.savedJSON)) {
                this.savedJSON = currentJSON;
                this.grid.trigger('change:state', this.convertState(currentJSON));
            }
        },
        onFiltersLoaded: function() {
            this.filtersLoaded = true;
        },
        setColumnOrder: function(columns) {
            var order = [];
            util.each(columns, function(column) {
                order.push(column.field);
            });
            this.set('columnOrder', order);
        },
        setHiddenColumns: function(columns) {
            var hidden = [];
            util.each(columns, function(column) {
                if (column.condition === false) {
                    hidden.push(column.field);
                }
            });
            this.set('hiddenColumns', hidden);
        },
        setFilters: function(filters) {
            if (!this.filtersLoaded) {
                return;
            }

            var stateFilters = {};
            util.each(filters, function(filter) {
                stateFilters[filter.field] = !util.isNullOrUndefined(filter.equality) ? this.setRangeFilterValue(filter) : filter.value;
            }, this);
            this.set('filters', stateFilters);
        },
        setRangeFilterValue: function(filter) {
            return {
                equality: filter.equality,
                value: filter.value
            };
        },
        setMultiColumnSort: function(columns, enabled) {
            var multiColumnData = [];

            if (this.has('multiColumnSort') && !columns) {
                multiColumnData = this.get('multiColumnSort');
            } else if (columns) {
                multiColumnData[0] = columns;
            }

            multiColumnData[1] = enabled;

            this.set('multiColumnSort', multiColumnData);
        },
        setColumnWidths: function(columns) {
            var columnsObject = {};
            util.each(columns, function(column) {
                if (column.width) {
                    columnsObject[column.field] = column.width;
                }
            });

            this.set('columnsWidth', columnsObject);
        }
    });
});

